import { render, staticRenderFns } from "./GoodsPackageSelectPopup.vue?vue&type=template&id=562419b2&scoped=true&"
import script from "./GoodsPackageSelectPopup.vue?vue&type=script&lang=js&"
export * from "./GoodsPackageSelectPopup.vue?vue&type=script&lang=js&"
import style0 from "./GoodsPackageSelectPopup.vue?vue&type=style&index=0&id=562419b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562419b2",
  null
  
)

export default component.exports